"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileAltProviders = exports.MobileAltProvidersHeader = exports.MobileAltProvidersContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const provider_components_1 = require("@kyruus/provider-components");
const ui_theme_1 = require("@kyruus/ui-theme");
exports.MobileAltProvidersContainer = styled_1.default.div `
  margin: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
`;
exports.MobileAltProvidersHeader = styled_1.default.h2 `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  margin: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;)};
`;
exports.MobileAltProviders = (0, styled_1.default)(provider_components_1.MiniProviderCardList) `
  > div {
    width: calc(50% - 8px);
  }

  @media (max-width: ${(0, ui_theme_1.fromTheme)('db_screen_small')}) {
    > div {
      width: 100%;
    }
  }
`;
//# sourceMappingURL=styles.js.map